import { styled } from "styled-components";
import AppCard from "../../AppCard";
import { css } from "styled-components";
import { AppsContainerSidebarCardProps } from ".";

export const StyledAppsContainerSidebarCard = styled(
  AppCard,
)<AppsContainerSidebarCardProps>`
  width: ${({ collapsed, minWidth, maxWidth }) =>
    collapsed ? minWidth || "auto" : maxWidth || "100%"};
  max-width: ${({ collapsed, minWidth, maxWidth }) =>
    collapsed ? minWidth || "auto" : maxWidth || "100%"};

  .ant-card {
    transition: all 0.5s ease;
    width: 100%;
    border-radius: ${({ theme }) => theme.cardRadius} !important;

    ${({ borderHeader }) =>
      borderHeader &&
      css`
        & > .ant-card-head {
          border: 1px dashed ${({ theme }) => theme.palette.borderColor};
        }
      `}

    ${({ borderHeader }) =>
      borderHeader &&
      css`
        & > .ant-card-head {
          background-color: ${({ theme }) =>
            theme.palette.background.secondary};
        }
      `}

    ${({ borderFull }) =>
      borderFull &&
      css`
        border: 1px dashed ${({ theme }) => theme.palette.borderColor};
      `}

    .ant-card-body {
      transition: all 0.5s ease;
      padding: 0;
    }
  }
`;
